import React from 'react';

const EmailHelpIcon = () => {
	return (
		<svg width='21' height='21' viewBox='0 0 21 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M2.58317 4.9987C2.99984 4.2487 3.83317 3.83203 4.6665 3.83203C7.58317 3.83203 13.4165 3.83203 16.3332 3.83203C17.1665 3.83203 17.9998 4.2487 18.4165 4.9987C18.4165 4.9987 12.8332 8.9987 10.9165 10.4154C10.6665 10.582 10.2498 10.582 9.9165 10.4154C8.08317 8.9987 2.58317 4.9987 2.58317 4.9987ZM11.9998 11.7487C11.1665 12.4154 9.9165 12.4154 9.08317 11.7487C7.33317 10.4987 2.1665 6.7487 2.1665 6.7487C2.1665 6.7487 2.1665 12.6654 2.1665 14.6654C2.1665 16.082 3.24984 17.1654 4.6665 17.1654C7.58317 17.1654 13.4165 17.1654 16.3332 17.1654C17.7498 17.1654 18.8332 16.082 18.8332 14.6654C18.8332 12.6654 18.8332 6.7487 18.8332 6.7487C18.8332 6.7487 13.6665 10.4987 11.9998 11.7487Z'
				fill='white'
			/>
		</svg>
	);
};

export default EmailHelpIcon;
